import { useEffect } from 'react';
import { useReduxAction } from '@engage/redux/hooks';
import type { PendingResult } from '@engage/result/pendingResult';
import { isOk } from '@engage/result/pendingResult';
import { mergeTogglesFromOptimizely } from './state/actions';

export const useFeatureToggles = (
  enabledFeatures: PendingResult<string[], undefined>,
) => {
  const doUpdate = useReduxAction(mergeTogglesFromOptimizely);
  useEffect(() => {
    if (isOk(enabledFeatures)) {
      doUpdate(enabledFeatures.value);
    }
  }, [enabledFeatures]);
};
